import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedVehicleSetup } from 'contracts/VehicleSetups';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_VEHICLE_SETUPS_',
  }
);

export interface ListVehicleSetupsState {
  data: ListedVehicleSetup[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListVehicleSetupsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedVehicleSetup[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListVehicleSetupsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListVehicleSetupsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListVehicleSetupsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListVehicleSetupsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListVehicleSetupsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listVehicleSetups = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListVehicleSetupsTypes = Types;
export const ListVehicleSetupsActions = Creators;
